export default __webpack_public_path__ + "static/media/blogimg2.480446f4.jpg";